import * as types from './actionTypes';

export const fetchRecruitmentRequisition = (unit_id) => ({
  type: types.FETCH_RECRUITMENT_REQUISITION_REQUEST,
  payload:{unit_id},
});

export const saveRecruitmentRequisition = (payload) => ({
  type: types.SAVE_RECRUITMENT_REQUISITION_REQUEST,
  payload,
});

export const changeRequisitionStatusRequest = (payload) => ({
  type: types.CHANGE_REQUISITION_STATUS_REQUEST,
  payload,
});

export const changeRequisitionStatusSuccess = (response) => ({
  type: types.CHANGE_REQUISITION_STATUS_SUCCESS,
  response,
});

export const changeRequisitionStatusFailure = (error) => ({
  type: types.CHANGE_REQUISITION_STATUS_FAILURE,
  error,
});